import { Typography } from '@mui/material';
import FlexContainer from 'components/FlexContainer';
import FormattedMessage from 'features/i18n/FormattedMessage';
import styled from 'styled-components';

type Props = {
  seatsLeft: number;
  totalTeamMemberCount: number;
  totalSeatsAvailable: number;
};

export const WorkspaceStatusTile = ({
  seatsLeft,
  totalTeamMemberCount,
  totalSeatsAvailable
}: Props) => {
  const noSeatsLeft = totalTeamMemberCount >= totalSeatsAvailable;

  return (
    <TileCard $isWarning={noSeatsLeft}>
      <VeryBigNumber>{seatsLeft}</VeryBigNumber>

      <TextContent>
        <Typography variant="subtitle1" color="inherit">
          <FormattedMessage id="profile.users.seats.title" />
        </Typography>

        <Typography variant="body2" color="inherit">
          <RightPushingText>
            <FormattedMessage
              id="profile.users.seats.used"
              values={{ used: totalTeamMemberCount }}
            />
          </RightPushingText>

          <FormattedMessage
            id="profile.users.seats.subtitle"
            values={{ total: totalSeatsAvailable }}
          />
        </Typography>
      </TextContent>
    </TileCard>
  );
};

const TileCard = styled(FlexContainer)<{ $isWarning?: boolean }>`
  width: 309px;
  padding: ${({ theme }) => theme.spacings.four};
  border: ${({ theme }) => `1px solid ${theme.colors.divider}`};
  border-radius: ${({ theme }) => theme.borderRadius.three};
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacings.three};
  color: ${({ $isWarning, theme }) => ($isWarning ? theme.colors.errorMain : 'inherit')};
  background-color: ${({ theme }) =>
    theme.mode === 'dark' && theme.colors.backgroundPaperElevation2};
`;

const VeryBigNumber = styled.div`
  width: 4.5rem;
  height: 3.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ theme }) => theme.typography.h3.fontSize};
  font-weight: ${({ theme }) => theme.typography.h3.fontWeight};
`;

const TextContent = styled(FlexContainer)`
  flex: 1;
  gap: ${({ theme }) => theme.spacings.one};
  align-items: flex-start;
`;

const RightPushingText = styled.span`
  margin-right: 4px;
`;
